export default __webpack_public_path__ + "static/node-testing-d4f4458628122ecde9b8d8169c80c8fa.png";